<template>
    <div class="container-fluid fixed-top pt-3 pb-2 bg-body-opacity-98 d-block d-lg-none">
        <div class="container">
            <div class="d-flex flex-wrap align-items-center" v-if="isCompanyContact">
                <div class="col-4 col-md-5"></div>
                <div class="col-4 col-md-2 mx-auto">
                    <a href="/account">
                        <img :src="brandLogo" alt="" class="light-mode-only mx-auto header-logo w-100" :class="{'mt-1': isOptima}" style="max-width:123px">
                        <img :src="darkmodeBrandLogo" alt="" class="dark-mode-only mx-auto header-logo w-100" :class="{'mt-1': isOptima}" style="max-width:123px">
                    </a>
                </div>
                <div class="col-4 col-md-5 text-end">
                    <a href="/profile" class="header-icon-wrapper">
                        <span class="notification-dot" v-if="profileInfoNotify"></span>
                        <img v-if="profileImage" class="profile-image" :src="profileImage">
                        <svg v-else class="header-icon-wrapper lucide lucide-circle-user" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="10" r="3"/><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"/></svg>
                    </a>
                </div>
                <div class="col-12 text-center">
                    <span>{{ officeName }} // {{ studentFullName }}</span>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-5 col-4">
                    <a href="/profile" class="header-icon-wrapper">
                        <span class="notification-dot" v-if="profileInfoNotify"></span>
                        <img v-if="profileImage" class="profile-image" :src="profileImage">
                        <svg v-else class="header-icon-wrapper lucide lucide-circle-user" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="10" r="3"/><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"/></svg>
                    </a>
                </div>
                <div class="col-md-2 col-4">
                    <a href="/">
                        <img :src="brandLogo" alt="" class="light-mode-only mx-auto header-logo w-100" :class="{'mt-1': isOptima}" style="max-width:123px">
                        <img :src="darkmodeBrandLogo" alt="" class="dark-mode-only mx-auto header-logo w-100" :class="{'mt-1': isOptima}" style="max-width:123px">
                    </a>
                </div>
                <div class="col-md-5 text-end col-4">
                    <span class="header-icon-wrapper me-1" @click="displayNotificationList">
                        <span class="notification-dot" v-if="unreadMessages && !markedAsRead"></span>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <a class="header-icon-wrapper" href="/messages" v-if="chatEnabled">
                        <span class="notification-dot" v-if="unreadChatMessages"></span>
                        <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" fill="none"
                             viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
                        </svg>
                    </a>
                </div>
                <div class="col-12 text-center">
                    <span class="text-sm fw-bold chevron-down-after position-relative px-3 cursor-pointer" @click="toggleOfficeDropdown">
                        <span v-if="studentName">{{ $t('{studentName} på {officeName}', { studentName, officeName }) }}</span>
                        <span v-if="!studentName">{{ officeName }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>
                    </span>
                    <div class="position-relative">
                        <div class="office-dropdown container" v-show="showOfficeDropdown">
                            <ul class="list-group d-inline-block mt-2">
                                <li class="list-group-item cursor-pointer fw-bold" v-for="office in officeList">
                                    <a :href="setOfficeLink(office)" class="text-decoration-none stretched-link" :class="{ 'text-secondary': !office.is_active, 'text-body': office.is_active }">
                                        <span v-if="office.is_contact == 1">{{ office.student.first_name.split(' ')[0] }} på </span>{{ office.office_name }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <NotificationList :showNotificationList="showNotificationList" @hide="hideNotificationList"></NotificationList>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import NotificationList from './NotificationList';
import Api from '../../api/BaseRequest';

const props = defineProps(['unreadmessages', 'unreadchatmessages', 'userimage', 'profileinfonotify', 'officename', 'isoslooffice', 'chatenabled']);

const unreadMessages = ref(props.unreadmessages);
const unreadChatMessages = ref(props.unreadchatmessages);
const userImage = ref(props.userimage);
const profileInfoNotify = ref(props.profileinfonotify);
const showNotificationList = ref(false);
const markedAsRead = ref(false);
const showOfficeDropdown = ref(false);
const officeName = ref(props.officename);
const isOptima = window.isOptima;
const officeList = ref([]);
const brandLogo = ref(window.brandLogoRegular);
const isCompanyContact = computed(() => window.isCompanyContact);

const studentFullName = computed(() => window.studentName);
const studentName = computed(() => window.studentName.split(' ')[0]);
const profileImage = computed(() => userImage.value);
const chatEnabled = computed(() => props.chatenabled);
const darkmodeBrandLogo = computed(() => window.isOptima ? window.brandLogoNoBg : window.brandLogoInverse);

onMounted(() => {
    Api.Get('/api/officelist').then((res) => {
        officeList.value = res;
    });
});

const displayNotificationList = () => {
    showNotificationList.value = true;
    markedAsRead.value = true;
    document.querySelectorAll('.app-bar')[0].classList.add('d-none');
};

const hideNotificationList = () => {
    showNotificationList.value = false;
    document.querySelectorAll('.app-bar')[0].classList.remove('d-none');
};

const toggleOfficeDropdown = () => {
    showOfficeDropdown.value = !showOfficeDropdown.value;
};

const setOfficeLink = (office) => {
    if (office.is_contact) {
        return `/change-student/${office.student.user_id}`;
    }
    return `/change-office/${office.office_id}`;
};
</script>

<style scoped>
    .office-dropdown {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
</style>